// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Navigation from "../../primitives/Navigation.res.js";
import * as ComplianceRoutes from "./ComplianceRoutes.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ComplianceVerifyCashRegisterArchivePage from "./ComplianceVerifyCashRegisterArchivePage.res.js";

function ComplianceRouter(props) {
  let subUrlPath = props.subUrlPath;
  if (subUrlPath !== 0 && subUrlPath.hd === "verify-cash-register-archive" && subUrlPath.tl === 0) {
    return JsxRuntime.jsx(ComplianceVerifyCashRegisterArchivePage.make, {});
  }
  return JsxRuntime.jsx(Navigation.Redirect.make, {
    route: ComplianceRoutes.baseRoute
  });
}

let make = ComplianceRouter;

export {
  make,
}
/* Navigation Not a pure module */
